import React from 'react';
import { Box, Container, Grid, Paper } from '@mui/material';
import { ProfilePageHeader, ProfileSidebar } from './components';
import { CareerStatus } from './constants';
import { ProfileContent, ProfilePictureModalContainer } from './containers';
import { useProfilePage } from './hooks';

export { CareerStatus };

/**
 * Profile page shell — same layout tokens as `/mui-preview`:
 * `Container maxWidth="xl"`, responsive `Grid` (sidebar stacks above content
 * on xs, 4/8 split on md, 3/9 on lg), `Paper` content card.
 * Relies on the global `MuiBrandProvider` from `app.tsx`; no nested theme.
 */
export const Profile = () => {
  const page = useProfilePage();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Container maxWidth="xl" sx={{ py: { xs: 2.5, sm: 3 } }}>
        <ProfilePageHeader userRole={page.userRole} />

        <Grid container spacing={2.5} alignItems="flex-start">
          <Grid item xs={12} md={4} lg={3}>
            <ProfileSidebar
              sections={page.profileSections}
              activeSection={page.activeSection}
              onSelect={page.setActiveSection}
            />
          </Grid>

          <Grid item xs={12} md={8} lg={9}>
            <Paper sx={{ overflow: 'hidden' }}>
              <ProfileContent
                activeSection={page.activeSection}
                firstName={page.firstName}
                lastName={page.lastName}
                email={page.email}
                phone={page.phone}
                bio={page.bio}
                jobTitle={page.jobTitle}
                profileLink={page.profileLink}
                profilePicStatus={page.profilePicStatus}
                userInitials={page.userInitials}
                userRole={page.userRole}
                isEditing={page.isEditing}
                loading={page.loading}
                isEmployee={page.isEmployee}
                jobTitleOptions={page.jobTitleOptions}
                selectedJobTitle={page.selectedJobTitle}
                careerStatus={page.careerStatus}
                notifications={page.notifications}
                onFirstNameChange={page.setFirstName}
                onLastNameChange={page.setLastName}
                onPhoneChange={page.setPhone}
                onBioChange={page.setBio}
                onJobTitleChange={page.handleJobTitleChange}
                onStartEdit={page.handleStartEdit}
                onSave={() => void page.handleSave()}
                onCancel={page.handleCancelEdit}
                onOpenPictureModal={() => page.setIsModalOpen(true)}
                onCareerStatusChange={(status) => void page.handleCareerStatus(status)}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <ProfilePictureModalContainer
        isOpen={page.isModalOpen}
        profileLink={page.profileLink}
        firstName={page.firstName}
        lastName={page.lastName}
        userRole={page.userRole}
        onProfileLinkChange={page.setProfileLink}
        onOpenChange={page.setIsModalOpen}
      />
    </Box>
  );
};
